export default "__VITE_ASSET__CHsSiWoa__"